import { createTheme } from "@mui/material/styles";

export default createTheme({
  palette: {
    primary: {
      main: "#5da355",
    },
  },
  zIndex: {
    modal: 1600,
  },
  components: {
    MuiModal: {
      styleOverrides: {
        root: {
          zIndex: 1600,
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        root: {
          zIndex: 1600,
        },
      },
    },
    MuiPopper: {
      styleOverrides: {
        root: {
          zIndex: 1600,
        },
      },
    },
  },
});
